import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import OrganizationOptionRenderer from '../../organization/OrganizationOptionRenderer';
import FormItem from '../../common/form/FormItem';
import { FILTER_FIELD_NAMES, Production_Field_Names, SORT_BY_PARENT_ORG } from '../helpers/productionUtils';
import FormWidget from '../../common/form/FormWidget';
import { ENTITY_CONSTANTS } from '../../common/constants/entityConstants';
import I18n from '../../common/i18n/I18n';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { UserContext } from '../../common/auth/UserContext';
import { FormContext } from '../../common/form/FormContext';
import { isEmpty } from 'lodash';
import Alert from '../../common/components/alert/Alert';

type OwnerOrganizationFormItemProps = {
    hideOwnerOrganization?: boolean;
    isDisabled?: boolean;
};

export default ({ hideOwnerOrganization = false, isDisabled = false }: OwnerOrganizationFormItemProps) => {
    const { userProfile } = useContext(UserContext);
    const { state } = useContext(FormContext);
    const initialOwnerOrgIdRef = useRef(state?.ownerOrganization?.id);
    const [showAlert, setShowAlert] = useState(false);

    // Get current the ownerOrganizationIds from the userProfile
    const ownerOrganizationIds = useMemo(
        () => userProfile.currentOwnerOrganizationIds,
        [userProfile.currentOwnerOrganizationIds]
    );
    // Default value should be first membership org
    const defaultValueIds =
        ownerOrganizationIds?.length > 0 && isEmpty(state?.ownerOrganization?.id) ? [ownerOrganizationIds[0]] : [];

    const filter = useMemo(
        () => ({
            expressions: [
                {
                    field: FILTER_FIELD_NAMES.identity,
                    value: {
                        values: ownerOrganizationIds
                    }
                }
            ]
        }),
        [ownerOrganizationIds]
    );

    useEffect(() => {
        // Only show alert if in edit form and ownerOrganization id changes
        if (state?.identity?.id) {
            setShowAlert(
                initialOwnerOrgIdRef.current !== undefined &&
                    initialOwnerOrgIdRef.current !== state?.ownerOrganization?.id
            );
        }
    }, [state?.ownerOrganization?.id, state?.identity?.id]);

    return (
        <>
            {showAlert && (
                <FormItem>
                    <Alert descriptionToken={'production.ownerOrganization.alert.message'} />
                </FormItem>
            )}
            <FormItem half hidden={hideOwnerOrganization}>
                <FormWidget
                    entity={ENTITY_CONSTANTS.organization}
                    component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                    name={Production_Field_Names.ownerOrganization}
                    label={<I18n token="common.owner.organization" />}
                    disabled={isDisabled}
                    preload={false}
                    OptionRenderer={OrganizationOptionRenderer}
                    sortBy={SORT_BY_PARENT_ORG}
                    defaultValueIds={defaultValueIds}
                    filter={filter}
                />
            </FormItem>
        </>
    );
};
